interface IDisplayDomProp {
  target: HTMLElement,
  show: () => void
  hide: () => void
  threshold: number | undefined
  once: boolean
  root: null
}

function DisplayDom (props: IDisplayDomProp) {
  const { target, show = () => {}, hide = () => {}, threshold = 0.01, once = false, root = null} = props
  try {
    const io = new window.IntersectionObserver(entries => {
      if (entries[0].intersectionRatio >= threshold) {
        show ()
        if (once) {
          stop()
        }
      } else {
        hide()
      }
    }, { threshold: [threshold], root })
    io.observe(target)
    const stop = () => {
      io.disconnect()
    }
  } catch (error) {
    console.error(error.message, '\n不支持IntersectionObserver，升级浏览器或代码使用polyfill: https://github.com/w3c/IntersectionObserver')
  }
}

export default {
  name: 'observer',
  action: {
    mounted (el, binding) {
      const { value, arg, modifiers } = binding
      el.observer = new DisplayDom({
        target: el,
        show: typeof value === 'function' ? value : value.show,
        hide: value.hide,
        threshold: (arg / 100) || undefined,
        once: modifiers.once,
        root: value.dom,
      })
    },
    unmounted (el) {
      if (el.observer && typeof el.observer.stop === 'function') {
        el.observer.stop()
      }
    },
  },
}